// import React from 'react'
import React from "react"
const Hr = () => {
     return (
          <>
               <hr style={{ margin: "auto", width: "90%" }} />

          </>
     )
}

export default Hr
